import template from './zoneSelection.html';

/* @ngInject */
function ZoneSelController(
  $scope,
  $window,
  ZoneSelectionRectService,
  ZoneSelectionPolyService,
  ZoneSelectionStore
) {
  const vm = this;

  vm.$onInit = init;
  vm.$postLink = postLink;
  vm.$onDestroy = destroy;
  // the rect methods;
  vm.enableRectCreation = ZoneSelectionRectService.enableRectCreation;
  vm.createDragOrResizeRect = ZoneSelectionRectService.createDragOrResizeRect;
  vm.cancelRectInteraction = ZoneSelectionRectService.cancelRectInteraction;
  vm.enableRectDrag = ZoneSelectionRectService.enableRectDrag;
  vm.enableResizeAtPoint = ZoneSelectionRectService.enableResizeAtPoint;
  // the poly methods
  vm.placePathMarker = ZoneSelectionPolyService.placePathMarker;
  vm.enablePointDragAndMarkerDeletion = ZoneSelectionPolyService.enablePointDragAndMarkerDeletion;
  vm.dragMarkerOrPath = ZoneSelectionPolyService.dragMarkerOrPath;
  vm.cancelAllDragAndAddOrDeleteMarker = ZoneSelectionPolyService.cancelAllDragAndAddOrDeleteMarker;
  vm.initiatePathDragOrPlaceMarker = ZoneSelectionPolyService.initiatePathDragOrPlaceMarker;
  vm.cancelMarkerPlacement = ZoneSelectionPolyService.cancelMarkerPlacement;
  vm.enableMarkerPlacement = ZoneSelectionPolyService.enableMarkerPlacement;

  function init() {
    vm.state = ZoneSelectionStore.state;

    vm.currentPath = $window.location.href;
  }

  function postLink() {
    const svgWatcher = $scope.$watch(() => $(`#zone-selection-${vm.camId}`).length, (newV) => {
      if (newV) {
        svgWatcher();
        vm.state.svg = $(`#zone-selection-${vm.camId}`)[0];
        vm.state.pt = vm.state.svg.createSVGPoint();

        vm.state.polyGroup = $('#poly-grouping');
        vm.state.polyMask = $('polygon.zone-shape');

        vm.state.polyZoneShadow = $('#zone-shadow');

        let dashoffset = 0;
        const polyWithBorder = vm.state.polyZoneShadow;
        const halfset = 1.5;
        const oneSec = 1000;
        vm.borderAnimate = setInterval(() => {
          dashoffset = dashoffset === halfset ? 0 : halfset;
          polyWithBorder[0].style['stroke-dashoffset'] = dashoffset;
        }, oneSec);
      }
    });
  }

  function destroy() {
    ZoneSelectionPolyService.destroy();

    clearInterval(vm.borderAnimate);
  }
}

export default {
  name: 'zoneSelection',
  template,
  controller: ZoneSelController,
  bindings: {
    camId: '<'
  }
};
